<script>
    import BlogSummary from '../components/BlogSummary.svelte';
    export let short = false;
    export let blogUrl = "vinkit_kestavaan_muutokseen";
    let title = "12 vinkkiä onnistuneeseen elämäntapamuutokseen";
    let author = "Mata";
    let blogDate = "13.3.2023";
    let titlePic = "2023/healthy.jpg";
    let firstPara = "Haikailetko viimeistään kevätlumien sulaessa kadonnutta alkuvuoden intoa ja treenimotivaatiota?";
</script>

<!-- Yhteenveto (etusivu ja blogitesktisivu) -->
{#if short}
<BlogSummary blogPath={blogUrl} title={title} titlePic={titlePic} blogDate={blogDate} firstPara={firstPara}></BlogSummary>

<!-- Artikkeli -->
{:else}
    <div class="blog page">
        <article class="container">
            <h1>Näin säilytät treenimotivaation<br><small> - 12 vinkkiä onnistuneeseen elämäntapamuutokseen</small></h1>
            <div class="blogDate">{author} | {blogDate}</div>
            <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')"></div>



<p>Haikailetko viimeistään kevätlumien sulaessa kadonnutta alkuvuoden intoa ja treenimotivaatiota?
    Teitkö sinäkin uudenvuoden lupauksen paremmasta elämästä? Jos vastasit kyllä, et ole ainoa.</p>
    
<p> Uusi vuosi on hyvä hetki katsoa eteenpäin ja aloittaa puhtaalta pöydältä. 
    Näillä vinkeillä onnistut tekemään projektista elämänmittaisen muutoksen.</p>
    
    <p>Ajattelin kerätä tähän listaan muutamia ajatuksia kestävän elämäntapamuutoksen taustalle, ja listasta tulikin yllättävän pitkä - siitäkin huolimatta ettei se ole kaiken kattava. Ehkä saat tästä kuitenkin poimittua jotain ideoita itsellesi.</p>
    
    <h2>Dynamosalin vinkit kestävään muutokseen</h2>

    <ol>
        <li><strong>Määrittele tavoitteesi.</strong> Tavoite voi olla esimerkiksi ensimmäinen leuanveto, 
            5 km yhtämittaista juoksua tai uusi kyykkyennätys. Painonpudotus ja kiinteytyminen ovat hyviä tavoitteita, 
            mutta tavoitteen seuraaminen voi olla haastavaa, sillä vaaka ei useinkaan näytä todellisia lukuja 
            kehittymisestä.</li>
        <li><strong>Ole suunnitelmallinen.</strong> Tee itsellesi viikko-ohjelma ja päätä jo edellisen viikon 
            loppuna mitä aiot tehdä seuraavalla viikolla. Tällöin sinun ei tarvitse enää viikon jokaisena päivänä 
            tehdä uudestaan päätöstä pitäisikö tänään lähteä&hellip; vai huomenna sittenkin&hellip;</li>
        <li><strong>Säännöllisyys</strong>. Treenaa vähintään kolme kertaa viikossa äläkä lipsu treenistä ilman 
            pätevää syytä. Jos sinulla ei ole aikaa treenata tuntia, tee lyhyempi treeni. Ja vaikka treenaaminen
            ei kiinnostaisikaan juuri sillä hetkellä, päätä treenata vaikka viisi minuuttia. Tärkeintä on, että
            aloitat treenin ja pysyt uskollisesti ohjelmassasi. Yksi lyhyempi treeni ei vaikuta pitkän aikavälin 
            tavoitteisiin mitenkään. Vain säännöllisyys ja sitoutuminen tuo tuloksia. 
            Myös arjen normaalit askareet on helpommin järjestettävissä, kun treenit tapahtuvat aina samaan 
            aikaan.</li>
        <li><strong>Älä ole ehdoton</strong>. Kun treeni jää välistä yllättävien menojen vuoksi tai flunssa iskee, 
            ei elämäntapamuutoksesi romahda siihen. Sinulla on kuitenkin vielä koko loppuelämäsi aikaa treenata. 
            Kaksi tai kolmekin päivää pois pelistä ei vaikuta mitään suuressa kuvassa. Pitkäjänteisyys on kaikessa 
            tekemisessä a ja o.</li>
        <li><strong>Löydä treenaamisen ilo</strong>. Harrasta lajia ja tee sellasia treenejä, 
            joista nautit ja joita voisit kuvitella tekeväsi vielä vuosienkin päästä. Jos salitreeni ei kerta kaikkiaan 
            nappaa, treenaa kotona tai lähde vaikka nyrkkeilemään. Jos juoksulenkki tuntuu tylsääkin tylsemmältä, kokeile 
            kiertoharjoittelua ryhmässä tai lähde vaikka kaverin kanssa pelaamaan tennistä. Jokaiselle löytyy varmasti
            joku laji jonka kokee itselleen mielekkääksi.</li>
        <li><strong>Muista monipuolisuus</strong>. Sisällytä viikkoon eri lajeja. 
            Haasta kroppaasi uusiin asentoihin, opettele uusia taitoja. Jos et itse keksi mitä tekisit, hanki 
            monipuolinen harjoitusohjelma. Monipuolinen harjoittelu kehittää kunnon eri osa-alueita:
            voima, nopeus, tasapaino, koordinaatio, liikkuvuus, kestävyys ja hapenottokyky sekä kehonkoostumus. 
            Monipuolisuus tekee arjesta mielenkiintoista, ja kenties odotat jo innolla seuraavaa treeniä.</li>
        <li><strong>Varaa aikaa palautumiselle.</strong> Muista sisällyttää viikkoon aikaa palautumiselle.
            Välipäivä treeneistä on hyvä pitää vähintään 1-2 kertaa viikossa. Välipäivänä voit tehdä palauttavaa 
            kävelyä tai muuta hyötyliikuntaa sekä kehonhuoltoa. Kuuntele kehoa, kevennä treeniä jos tuntuu että 
            juuri tänään kroppa kaipaa enemmän huoltoa kuin rääkkiä.</li>
        <li><strong>Nuku riittävästi!</strong> Tämä lienee tärkein kohta kaikista. Kun olet virkeä, myös treenaaminen
            sujuu paremmin, teet parempia valintoja ruokakaupassa ja kitisevät lapset tai tyhmiä kyselevät työkaverit 
            tuntuvat huomattavasti siedettävämmältä. Stressi vaikuttaa helposti unen laatuun, ja liian vähäinen uni 
            pahentaa stressiä - siitä syntyykin jo helposti oravanpyörä. Useimmat tarvitsevat 7-8 tuntia hyvää yöunta 
            vuorokaudessa. Näyttöjen valo heikentää melatoniinin tuotantoa ilta-aikaan, joten tietokone 
            ja TV on parempi sulkea viimeistään tunti ennen nukkumaanmenoa. Mene nukkumaan niin aikaisin 
            että et tarvitse herätyskelloa aamulla.</li>
        <li><strong>Syö riittävästi</strong> ja riittävän usein laadukasta ruokaa! Jos haluat näyttää urheilijalta,
            sinun tulee myös treenata ja syödä kuin urhelija. Tarvitset siis joka päivä reilusti täysipainoista,
            monipuolista ravintoa, mieluiten jaettuna sopiviin annoksiin pitkin päivää. Useimmille toimii n. 5-6
            ateriaa päivässä. Muista että aina kun laitat ruokaa suuhusi, on sinulla mahdollisuus ravita kroppaasi 
            hyvillä ravintoaineilla. Valitse siis fiksusti!</li>
        <li><strong>Stressinhallinta</strong>. Elimistö ei osaa erottaa fyysistä ja henkistä stressiä, joten tiukan
            työpaineen alla treenikään ei kulje. Treeni aiheuttaa elimistölle stressiä, kuten myös huono ruokavalio
            tai vähäinen uni. On kuitenkin tutkimukseen perustuvaa näyttöä siitä että hyvä kunto vähentää stressiä,
            joten sopivasti annosteltuna on liikunta ja terveet elämäntavat tärkeä pitää mukana silloinkin kun tuntuu
            että stressi iskee ja elämä kaatuu päälle.</li>
        <li><strong>Anna tilaa tunteille!</strong> Älä vastusta niitä. On ok olla väsynyt, nälkäinen tai vihainen.
            Mitä enemmän taistelet tunteita vastaan, sitä enemmän joudut käyttämään voimavarojasi kamppaillaksesi 
            itseäsi vastaan. Sen sijaan, kohtaa tunteet ja käsittele ne asianmukaisesti. Älä myöskään jää murehtimaan
            ja ruokkimaan negatiivisia tunteita. Jos tekee mieli syödä suklaalevy ja pussillinen perunalastuja
            limsoineen yhdeltä istumalta, mistä tunne johtuu? Onko se opittu tapa (tekee mieli hemmotella itseä
            aina perjantaina työviikon jälkeen), tai johtuuko väliin jääneestä lounaasta (hirveä nälkä,
            matala verensokeri)? Opi hyväksymään tunteet, vain siten pystyt käsittelemään ne.</li>
        <li><strong>Höllää välillä.</strong> Muista että välillä on lupa myös herkutella ja ottaa rennosti. Kun 
            rutiinit on kunnossa, on sinulla täysi lupa silloin tällöin nauttia myös niistä ruokaympyrän heikommista 
            &quot;sattumista&quot;.</li>
    </ol>

    
    <img src="/svelte-site/img/blog/2023/handstand.jpg" alt="">
    <p class="kuvateksti">Kuva: Pixabay</p>

    <p>Anna treenaamisesta tulla tapa. Uudet tavat syntyvät jo muutamassa viikossa. 
        Kun sitoudut ensimmäisiin viikkoihin uskollisesti, niin treenaamisesta tulee tapa. 
        Pian et enää osaakaan kuvitella elämää ilman säännöllistä liikettä.</p>
        
    <p>Tsemppiä elämänmittaiseen muutokseen!</p>

    <p>-Mata</p>




</article>




<section class="container">
    <h2>Lue seuraavaksi</h2>
    <div class="row">
        <article class="blog col-xs-12 col-md-4">
            <BlogSummary blogPath='miten-tehda-treenaamisesta-hauskaa' title='Miten tehdä treenaamisesta hauskaa?' titlePic='dynamopaidat.jpg' blogDate='' firstPara='Salilla on kiva käydä ja siitä tulee keskimäärin mukavampaa, jos siellä kehittyy. Eikö vain?'></BlogSummary>
        </article>
        <article class="blog col-xs-12 col-md-4">
            <BlogSummary blogPath='juoksuvoimaa_lihaskuntoharjoittelusta' 
            title='Juoksuvoimaa lihaskuntoharjoittelusta' titlePic='2018/juoksutreenit.jpg' firstPara='Lihasten toimintakyky on kestävyyslajeissa oleellisessa roolissa ja vahva jaksaa pidemmälle. Voimaa tarvitaan niin eteenpäin vievään liikkeeseen kuin hyvän ryhdin ylläpitämiseen.' blogDate=''></BlogSummary>
        </article>
        <article class="blog col-xs-12 col-md-4">
            <BlogSummary blogPath='treenimotivaatio' title='Minne menit, treenimotivaatio?' 
            titlePic='2016/renkaat.jpg' firstPara='Treenimotivaatio on tärkeä elementti harjoittelun aloittamisen, mutta etenkin jatkamisen kannalta. Mistä löytää kadonnut motivaatio säännöllisen harjoittelun jatkamiseksi?' blogDate=''></BlogSummary>
        </article>
    </div>
</section>




</div>
{/if}

<style>




</style>